/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { useDtfStore } from "../store";
import { cn } from "tailwind-variants";
import "./UploadGangSheet.scss";

export default function UploadGangSheet({ currentStore, ...restProps }: any) {
  const store = useDtfStore();

  function gangSheetBuilderSettings() {
    // @ts-expect-error TS(4111): Property 'gangSheetBuilderSettings' comes from an ... Remove this comment to see the full error message
    return store.gangSheetBuilderSettings;
  }

  function gangSheetBuilderVariants() {
    // @ts-expect-error TS(4111): Property 'gangSheetBuilderVariants' comes from an ... Remove this comment to see the full error message
    return store.gangSheetBuilderVariants;
  }

  function variantUrl() {
    // @ts-expect-error TS(2769): No overload matches this call.
    const variantObj = Object.values(gangSheetBuilderVariants()).find(
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      variant => variant.variant_id === gangSheetBuilderSettings().variantId
    );
    return currentStore === "ca"
      ? // @ts-expect-error TS(2571): Object is of type 'unknown'.
        `/${currentStore}/${variantObj.product_slug}.html`
      : // @ts-expect-error TS(2571): Object is of type 'unknown'.
        `/${variantObj.product_slug}.html`;
  }

  return (
    <div {...restProps} className={cn("gang-sheet-builder-upload", restProps.className)}>
      {" "}
      Have a print-ready file?{" "}
      <a
        className="gang-sheet-builder-upload__link"
        href={variantUrl()}
        data-testid="gang-sheet-builder-upload-link"
      >
        {" "}
        Upload Your Gang Sheet{" "}
      </a>
    </div>
  );
}
